import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { responsibilitiesAPI } from '../../services/api';

// Асинхронные экшены
export const fetchResponsibilities = createAsyncThunk(
  'responsibilities/fetchResponsibilities',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await responsibilitiesAPI.getAll(params);
      return {
        data: response.data,
        params
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchResponsibilityById = createAsyncThunk(
  'responsibilities/fetchResponsibilityById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await responsibilitiesAPI.getById(id);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Slice
const responsibilitiesSlice = createSlice({
  name: 'responsibilities',
  initialState: {
    items: [],
    selectedResponsibility: null,
    loading: false,
    error: null,
    pagination: {
      page: 1,
      limit: 10,
      total: 0,
      pages: 1
    }
  },
  reducers: {
    updateResponsibility: (state, action) => {
      const responsibility = action.payload;
      const index = state.items.findIndex(item => item.id === responsibility.id);

      if (index !== -1) {
        state.items[index] = {
          ...state.items[index],
          ...responsibility,
        };
      } else {
        state.items.push(responsibility);
      }

      if (state.selectedResponsibility && state.selectedResponsibility.id === responsibility.id) {
        state.selectedResponsibility = {
          ...state.selectedResponsibility,
          ...responsibility,
        };
      }
    },

    deleteResponsibility: (state, action) => {
      const id = action.payload;
      const idStr = id?.toString();

      if (!idStr) {
        console.error('Редьюсер: получен пустой ID для удаления ответственности');
        return;
      }

      state.items = state.items.filter(item => {
        const itemId = item.id?.toString();
        return itemId !== idStr;
      });

      if (state.selectedResponsibility && state.selectedResponsibility.id?.toString() === idStr) {
        state.selectedResponsibility = null;
      }
    },

    resetSelectedResponsibility: (state) => {
      state.selectedResponsibility = null;
    },

    setPagination: (state, action) => {
      state.pagination = {
        ...state.pagination,
        ...action.payload
      };
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchResponsibilities.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchResponsibilities.fulfilled, (state, action) => {
        const { data, params } = action.payload;

        if (data && data.data && Array.isArray(data.data)) {
          state.items = data.data;

          if (data.pagination) {
            state.pagination = {
              page: params.page || 1,
              limit: params.limit || 10,
              total: data.pagination.total || 0,
              pages: Math.ceil(data.pagination.total / (params.limit || 10)) || 1
            };
          }
        } else if (Array.isArray(data)) {
          state.items = data;
          state.pagination = {
            ...state.pagination,
            total: data.length,
            pages: Math.ceil(data.length / (params.limit || 10)) || 1
          };
        }

        state.loading = false;
      })
      .addCase(fetchResponsibilities.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Не удалось загрузить ответственности';
      })

      .addCase(fetchResponsibilityById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchResponsibilityById.fulfilled, (state, action) => {
        state.selectedResponsibility = action.payload;
        state.loading = false;
      })
      .addCase(fetchResponsibilityById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Не удалось загрузить ответственность';
      });
  },
});

// Экспорт экшенов
export const {
  updateResponsibility,
  deleteResponsibility,
  resetSelectedResponsibility,
  setPagination
} = responsibilitiesSlice.actions;

// Селекторы
export const selectAllResponsibilities = (state) => state.responsibilities.items;
export const selectSelectedResponsibility = (state) => state.responsibilities.selectedResponsibility;
export const selectResponsibilitiesLoading = (state) => state.responsibilities.loading;
export const selectResponsibilitiesError = (state) => state.responsibilities.error;
export const selectResponsibilitiesPagination = (state) => state.responsibilities.pagination;

// Экспорт редьюсера
export default responsibilitiesSlice.reducer;
